import { transform, type TransformedCheckoutData } from "../transformers/CheckoutViewDataTransformer";
import type { CheckoutViewDTO } from "~/features/cart/cart/dto/CheckoutViewDTO";

export async function getData(url: string): Promise<TransformedCheckoutData> {
  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  const dto: CheckoutViewDTO = await response.json();

  return transform(dto);
}
